
// Section.js - Modern Accordion Component
import React from "react";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";

function Section(props) {
  return (
    <div className="flex flex-col items-center justify-center w-full sm:w-11/12 md:w-10/12 lg:w-10/12 xl:w-9/12 mx-auto my-6">
      <div className="w-full bg-white/80 backdrop-blur-md rounded-2xl shadow-lg border border-gray-200/50 overflow-hidden">
        {/* Header */}
        <div
          className="bg-gradient-to-r from-[#10c9c0] to-[#0ea5a0] p-6 cursor-pointer transition-all duration-300 hover:from-[#0ea5a0] hover:to-[#10c9c0] text-white flex justify-between items-center group"
          onClick={props.onClick}
        >
          <div className="flex items-center space-x-4">
            {/* Icon based on header */}
            <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center">
              {props.header === "Maps and Access" && (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              )}
              {props.header === "Amenities" && (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                </svg>
              )}
              {props.header === "Blogs" && (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              )}
            </div>
            <h2 className="text-xl sm:text-2xl md:text-3xl font-bold">
              {props.header}
            </h2>
          </div>
          
          <div className="transform transition-transform duration-300 group-hover:scale-110">
            {props.isOpen ? (
              <IoIosArrowUp className="text-2xl sm:text-3xl" />
            ) : (
              <IoIosArrowDown className="text-2xl sm:text-3xl" />
            )}
          </div>
        </div>
        
        {/* Content */}
        <div
          className={`overflow-hidden transition-all duration-500 ease-in-out ${
            props.isOpen ? "max-h-[2000px] opacity-100" : "max-h-0 opacity-0"
          }`}
        >
          <div className="p-6 lg:p-8 bg-gradient-to-br from-gray-50 to-white">
            {props.data}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Section;
